// extracted by mini-css-extract-plugin
export default {"wrapper":"DataCollection_wrapper__FFPqa","info":"DataCollection_info__Onx6B"};